<template>
  <template v-if="showMenuFooterApps()">
    <div v-for="(section, index) in MenuFooterAppsInstance" :key="index">
      <MenuFooterAppsSection :section="section" />
    </div>
  </template>
</template>

<script setup lang="ts">
import {
  useMenuFooterApps,
  showMenuFooterApps,
} from '../composables/useMenuFooterApps'

const { MenuFooterAppsInstance } = await useMenuFooterApps()
</script>
